// let productUrl = document.querySelector('[data-product-url]').dataset.productUrl;
// let sectionId = document.querySelector('[data-product-section-id]').dataset.productSectionId;
// let variantId = document.querySelector('[data-product-variant-id]').dataset.productVariantId;
// // `variantId` is set to the current variant's id. Replace this value with the updated variant's id

// // Fetch updated HTML from Section Rendering API
// fetch(`${productUrl}?section_id=${sectionId}&variant=${variantId}`)
//   .then((response) => response.text())
//   .then((responseText) => {
//   // Replace the current HTML in DOM with the updated HTML

//   const updatedHtml = new DOMParser().parseFromString(responseText, 'text/html');

//   // Update the quantity rules
//   const currentQuantityRules = document.querySelector(`#QuantityRules-${sectionId}`);
//   const updatedQuantityRules = updatedHtml.querySelector(`#QuantityRules-${sectionId}`);
//   currentQuantityRules.innerHTML = updatedQuantityRules.innerHTML;
// });

// // Fetch updated HTML from Section Rendering API
// fetch(`${productUrl}?section_id=${sectionId}&variant=${variantId}`)
//   .then((response) => response.text())
//   .then((responseText) => {
//   // Replace the current HTML in DOM with the updated HTML

//   const updatedHtml = new DOMParser().parseFromString(responseText, 'text/html');

//   // Update the cart quantity
//   const currentCartQuantity = document.querySelector(`#CartQuantity-${sectionId}`);
//   const updatedCartQuantity = updatedHtml.querySelector(`#CartQuantity-${sectionId}`);
//   // currentCartQuantity.innerHTML = updatedCartQuantity.innerHTML;
// });

// console.log("hello1");
// $(".samitaWS-original-atc-button").hide();
// console.log("hello2");

// Year Filter

var ddlYears = $("#select_year");

//Determine the Current Year.
var currentYear = new Date().getFullYear();

//Loop and add the Year values to DropDownList.
for (var i = 1982; i <= currentYear; i++) {
  var option = $("<option />");
  option.html(i);
  option.val(i);
  ddlYears.append(option);
}

// B2B Product Quantity Selector

$("body").on("click", ".tz-discount-btn", function () {
  var value = $(this).val();
  var tz_quantity_selector = $("quantity-selector")
    .find(".quantity-selector__input")
    .val(value);
});

// Discount Checkbox

$(function () {
  $("#discount-text").click(function () {
    if ($(this).is(":checked")) $(".discountcodefield").removeClass("hide");
    //alert('checked');
    else $(".discountcodefield").addClass("hide");
    //alert('unchecked');
  });
});

// Discount Cart Javascript

$(document).ready(function () {
  $(".discount_code_btn").click(function () {
    var discountStored = $('input[name="discount_code"]').val();
    $('input[name="discount"]').val(discountStored);
    $(".discount_apply_code").html(
      '<div><svg class="icon-sale-tag-2" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 350 350" fill="none">      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M0 197.826C0 192.95 1.93821 188.275 5.38762 184.83L179.459 10.7587C186.348 3.86966 195.692 -0.000356971 205.435 2.46966e-08H334.782C343.187 2.46966e-08 350 6.81304 350 15.2173V144.565C350 154.308 346.13 163.651 339.241 170.541L165.17 344.612C161.725 348.061 157.049 350 152.174 350C147.299 350 142.624 348.061 139.179 344.612L5.38762 210.821C1.93821 207.376 0 202.701 0 197.826ZM304.348 68.4786C304.348 81.085 294.128 91.3046 281.521 91.3046C268.915 91.3046 258.695 81.085 258.695 68.4786C258.695 55.8721 268.915 45.6525 281.521 45.6525C294.128 45.6525 304.348 55.8721 304.348 68.4786Z"></path></svg><strong>' +
        discountStored +
        '</strong> applied on checkout page. <a href="javascript:void(0);" class="clear-discount">Remove</a></div>'
    );
    localStorage.setItem("storedDiscount", discountStored);
    $('input[name="discount_code"]').val("");
  });

  $(document).on("click", "a.clear-discount", function (event) {
    var discountStored = "";
    $('input[name="discount"]').val(discountStored);
    $(".discount_apply_code").html("");
    var deletenum = "storedDiscount";
    localStorage.removeItem(deletenum);
  });

  if (localStorage.getItem("storedDiscount")) {
    var discountStored = localStorage.getItem("storedDiscount");
    if (discountStored != "" && discountStored != "undefined") {
      $('input[name="discount"]').val(localStorage.getItem("storedDiscount"));
      $(".discount_apply_code").html(
        '<div><svg class="icon-sale-tag-2" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 350 350" fill="none">      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M0 197.826C0 192.95 1.93821 188.275 5.38762 184.83L179.459 10.7587C186.348 3.86966 195.692 -0.000356971 205.435 2.46966e-08H334.782C343.187 2.46966e-08 350 6.81304 350 15.2173V144.565C350 154.308 346.13 163.651 339.241 170.541L165.17 344.612C161.725 348.061 157.049 350 152.174 350C147.299 350 142.624 348.061 139.179 344.612L5.38762 210.821C1.93821 207.376 0 202.701 0 197.826ZM304.348 68.4786C304.348 81.085 294.128 91.3046 281.521 91.3046C268.915 91.3046 258.695 81.085 258.695 68.4786C258.695 55.8721 268.915 45.6525 281.521 45.6525C294.128 45.6525 304.348 55.8721 304.348 68.4786Z"></path></svg><strong>' +
          discountStored +
          '</strong> applied on checkout page. <a href="javascript:void(0);" class="clear-discount">Remove</a></div>'
      );
    }
  }

  // Calculate Discount Amount

  // Function to get the cart data
    // function getCartData() {
    //     return $.getJSON('/cart.js');
    // }

    // Function to parse and clean price strings
    // function parsePrice(priceText) {
    //     // Remove all non-numeric characters except for decimal points
    //     var cleanedPrice = priceText.replace(/[^\d.,]/g, '');
    //     // Convert to a float (handle both comma and dot as decimal separators)
    //     return parseFloat(cleanedPrice.replace(/,/g, ''));
    // }

    // Function to calculate the difference between original and customized prices
    // function calculatePriceDifference() {
    //     var originalPriceText = $('.samitaWS-customized-original-price').text().trim();
    //     var customizedPriceText = $('.samitaWS-customized-price').text().trim();

    //     var originalPrice = parsePrice(originalPriceText);
    //     var customizedPrice = parsePrice(customizedPriceText);

    //     var difference = originalPrice - customizedPrice;

    //     console.log('Original Price:', originalPrice);
    //     console.log('Customized Price:', customizedPrice);
    //     console.log('Difference:', difference);
    // }

    // Function to handle cart updates
    // function handleCartUpdate() {
    //     getCartData().done(function(cart) {
    //         // Call the function to calculate the price difference
    //         calculatePriceDifference();
    //     });
    // }

    // Check for cart updates periodically
    // var cartUpdateInterval = 5000; // 5 seconds
    // var lastCartData = '';

    // setInterval(function() {
    //     getCartData().done(function(cart) {
    //         // Compare the current cart data with the last data
    //         var currentCartData = JSON.stringify(cart);
    //         if (currentCartData !== lastCartData) {
    //             lastCartData = currentCartData;
    //             handleCartUpdate();
    //         }
    //     });
    // }, cartUpdateInterval);

    // calculatePriceDifference();
});

// Discount Checkout Javascript
(function () {
  var jquery = null;

  if (window.jQuery) {
    jquery = window.jQuery;
  } else if (window.Checkout && window.Checkout.$) {
    jquery = window.Checkout.$;
  }

  jquery(document).on(
    "click",
    "button.applied-reduction-code__clear-button",
    function (event) {
      var deletenum = "storedDiscount";
      localStorage.removeItem(deletenum);
      var url = window.location.href;
      console.log(url);
      var return_url = removeURLParameter(url, "discount");
      window.location.href = return_url;
    }
  );

  jquery(document).on("click", "button.field__input-btn", function (event) {
    var value = jquery("#checkout_reduction_code").val();
    updateQueryStringParam("discount", value);
  });
})();

function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split("?");
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    url = urlparts[0] + "?" + pars.join("&");
    return url;
  } else {
    return url;
  }
}

// Explicitly save/update a url parameter using HTML5's replaceState().
function updateQueryStringParam(key, value) {
  baseUrl = [location.protocol, "//", location.host, location.pathname].join(
    ""
  );
  urlQueryString = document.location.search;
  var newParam = key + "=" + value,
    params = "?" + newParam;

  // If the "search" string exists, then build params from it
  if (urlQueryString) {
    keyRegex = new RegExp("([?&])" + key + "[^&]*");
    // If param exists already, update it
    if (urlQueryString.match(keyRegex) !== null) {
      params = urlQueryString.replace(keyRegex, "$1" + newParam);
    } else {
      // Otherwise, add it to end of query string
      params = urlQueryString + "&" + newParam;
    }
  }
  window.history.replaceState({}, "", baseUrl + params);
}

// Reload Product Page when product added in cart

// document.addEventListener("DOMContentLoaded", function () {
//   // Function to check for cart updates
//   function checkCart() {
//     fetch("/cart.js")
//       .then((response) => response.json())
//       .then((cart) => {
//         // Check if there's a change in the number of items in the cart
//         if (cart.item_count > window.previousItemCount) {
//           // console.log("hello");
//           window.previousItemCount = cart.item_count;
//           window.location.reload(); // Reload the page
//         }
//       });
//   }

//   // Initialize the previous item count
//   window.previousItemCount = 0;

//   // Event listener for cart updates
//   document.addEventListener("submit", function (event) {
//     if (event.target.matches('form[action="/cart/add"]')) {
//       event.preventDefault(); // Prevent the default form submission
//       const formData = new FormData(event.target);
//       fetch(event.target.action, {
//         method: "POST",
//         body: formData,
//       }).then((response) => {
//         if (response.ok) {
//           checkCart(); // Check the cart after adding the item
//         }
//       });
//     }
//   });

//   // Initial check
//   // checkCart();
// });

// $(".samitaWS-original-atc-button").click(function () {
//   window.location.reload();
//   console.log("hello");
// });
